'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compose = require('../lib/compose');

var _compose2 = _interopRequireDefault(_compose);

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _inputValidations = require('../input-validations');

var _inputValidations2 = _interopRequireDefault(_inputValidations);

var _label = require('../label');

var _label2 = _interopRequireDefault(_label);

var _results = require('./results');

var _results2 = _interopRequireDefault(_results);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputSearch = function (_Component) {
  _inherits(InputSearch, _Component);

  function InputSearch(props) {
    _classCallCheck(this, InputSearch);

    var _this = _possibleConstructorReturn(this, (InputSearch.__proto__ || Object.getPrototypeOf(InputSearch)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.showMore = _this.showMore.bind(_this);
    _this.clearSelection = _this.clearSelection.bind(_this);
    _this.setActiveItem = _this.setActiveItem.bind(_this);

    if (props.debounce) {
      _this.handleChange = (0, _debounce2.default)(_this.handleChange, props.debounce);
    }

    _this.state = {
      query: '',
      active: -1,
      toShow: props.limit
    };
    return _this;
  }

  _createClass(InputSearch, [{
    key: 'handleChange',
    value: function handleChange(e) {
      var query = e.target.value;
      if (this.refs.results) this.refs.results.scrollTop = 0;
      this.setState({ query: query }, this.sendQuery);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      switch (e.key) {
        case 'ArrowUp':
          e.preventDefault();
          return this.setActiveItem(this.state.active - 1);
        case 'ArrowDown':
          e.preventDefault();
          return this.setActiveItem(this.state.active + 1);
        case 'Enter':
          e.preventDefault();
          return this.confirmSelection();
        case 'Escape':
          e.preventDefault();
          if (this.props.value) {
            return this.clearSelection();
          } else {
            return this.clearActive();
          }
        case 'Backspace':
          if (this.props.value) {
            e.preventDefault();
            return this.clearSelection();
          } else if (this.state.active !== -1) {
            e.preventDefault();
            return this.clearActive();
          } else {
            return null;
          }
        default:
          return null;
      }
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside() {
      this.props.closeOnClickOutside && this.clearActive();
    }
  }, {
    key: 'sendQuery',
    value: function sendQuery(query) {
      this.props.onSearch(this.state.query);
    }
  }, {
    key: 'setActiveItem',
    value: function setActiveItem(newIndex, selectItem) {
      var results = this.props.results;


      if (results.length) {
        var isLast = newIndex < 0;
        var isFirst = newIndex >= results.length;
        var active = isLast ? results.length - 1 : isFirst ? 0 : newIndex;

        var resultsEl = this.refs.results;
        var selectedEl = resultsEl.querySelector('[data-selected="' + active + '"]');

        resultsEl.scrollTop = selectedEl && selectedEl.offsetTop;
        this.setState({ active: active }, selectItem && this.confirmSelection);
      }
    }
  }, {
    key: 'confirmSelection',
    value: function confirmSelection() {
      var active = this.state.active;
      var _props = this.props,
          onChange = _props.onChange,
          results = _props.results;

      var selectedResult = results[active];

      onChange(selectedResult);
      this.clearActive();
    }
  }, {
    key: 'clearActive',
    value: function clearActive() {
      this.setState({
        query: '',
        active: -1,
        toShow: this.props.limit
      });
    }
  }, {
    key: 'clearSelection',
    value: function clearSelection() {
      this.props.onChange();
      this.refs.input.focus();
    }
  }, {
    key: 'showMore',
    value: function showMore() {
      var toShow = this.state.toShow;
      var limit = this.props.limit;

      this.setState({
        toShow: toShow + limit
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          autoComplete = _props2.autoComplete,
          autoFocus = _props2.autoFocus,
          classNames = _props2.classNames,
          emptyMessage = _props2.emptyMessage,
          error = _props2.error,
          errorMessage = _props2.errorMessage,
          icon = _props2.icon,
          id = _props2.id,
          label = _props2.label,
          name = _props2.name,
          _onBlur = _props2.onBlur,
          placeholder = _props2.placeholder,
          readOnly = _props2.readOnly,
          required = _props2.required,
          ResultComponent = _props2.ResultComponent,
          results = _props2.results,
          showMore = _props2.showMore,
          status = _props2.status,
          styles = _props2.styles,
          type = _props2.type,
          validations = _props2.validations,
          value = _props2.value,
          valueFormatter = _props2.valueFormatter;
      var _state = this.state,
          active = _state.active,
          query = _state.query,
          toShow = _state.toShow;


      var inputId = id || name;
      var labelId = 'label-' + inputId;

      return _react2.default.createElement(
        'div',
        {
          className: 'c11n-input-search ' + classNames.root,
          onKeyDown: this.handleKeyDown
        },
        label && _react2.default.createElement(
          _label2.default,
          {
            id: labelId,
            inputId: inputId,
            placeholder: placeholder,
            readOnly: readOnly,
            required: required,
            styles: {
              root: styles.label,
              required: styles.required
            }
          },
          label
        ),
        _react2.default.createElement(
          'div',
          { className: classNames.fieldWrapper },
          _react2.default.createElement('input', {
            'aria-labelledby': labelId,
            autoFocus: autoFocus,
            autoComplete: autoComplete,
            className: classNames.field,
            type: type,
            id: inputId,
            name: name,
            placeholder: placeholder,
            readOnly: readOnly || !!value,
            ref: 'input',
            required: required,
            onChange: function onChange(e) {
              e.persist && e.persist();
              _this2.handleChange(e);
            },
            onBlur: function onBlur(e) {
              return _onBlur && _onBlur(e.target.value);
            }
          }),
          value ? _react2.default.createElement(
            'div',
            { onClick: this.clearSelection },
            _react2.default.createElement(
              'div',
              { className: classNames.selected },
              valueFormatter(value)
            ),
            _react2.default.createElement(
              'div',
              { className: classNames.icon },
              _react2.default.createElement(_icon2.default, { name: 'close' })
            )
          ) : icon && _react2.default.createElement(
            'div',
            { className: classNames.icon },
            _react2.default.createElement(_icon2.default, { name: icon })
          ),
          query && _react2.default.createElement(
            'div',
            { className: classNames.results, ref: 'results' },
            _react2.default.createElement(
              _results2.default,
              {
                active: active,
                classNames: classNames,
                emptyMessage: emptyMessage,
                errorMessage: errorMessage,
                ResultComponent: ResultComponent,
                results: results,
                selectItem: this.setActiveItem,
                status: status,
                toShow: toShow
              },
              showMore && results.length > toShow && _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: classNames.showMore,
                  onClick: this.showMore
                },
                _react2.default.createElement(
                  'span',
                  null,
                  'Load More'
                ),
                ' ',
                _react2.default.createElement(_icon2.default, { name: 'chevron', rotate: 90, size: 0.75 })
              )
            )
          )
        ),
        error && _react2.default.createElement(_inputValidations2.default, {
          styles: { root: styles.error },
          validations: validations
        })
      );
    }
  }]);

  return InputSearch;
}(_react.Component);

InputSearch.propTypes = {
  /**
   * The length of time to debounce (false to disable debounce)
   */
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]),

  /**
   * The message to display when no results are found
   */
  emptyMessage: _propTypes2.default.string,

  /**
   * The message to display when there is an error
   */
  errorMessage: _propTypes2.default.string,

  /**
   * If the field is in an error state
   */
  error: _propTypes2.default.bool,

  /**
   * The icon to display on the right of the field (false to hide)
   */
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),

  /**
   * The ID of the input field
   */
  id: _propTypes2.default.string,

  /**
   * The label of the input field
   */
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),

  /**
   * The number of results to show
   */
  limit: _propTypes2.default.number,

  /**
   * The name of the input
   */
  name: _propTypes2.default.string,

  /**
   * The function to call when a user selects an item
   */
  onChange: _propTypes2.default.func,

  /**
   * The function to call when a user blurs the input
   */
  onBlur: _propTypes2.default.func,

  /**
   * The function to call when the search is altered
   */
  onSearch: _propTypes2.default.func.isRequired,

  /**
   * A component that is used to render each individual result
   */
  ResultComponent: _propTypes2.default.func,

  /**
   * The array of currently applicable results
   */
  results: _propTypes2.default.array,

  /**
   * Whether the field is required or not
   */
  required: _propTypes2.default.bool,

  /**
   * The currently selected value (useful if your values are objects with various keys e.g. id, label)
   */
  value: _propTypes2.default.any,

  /**
   * A function to format the value to display on the label
   */
  valueFormatter: _propTypes2.default.func,

  /**
   * Enables a Show More button
   */
  showMore: _propTypes2.default.bool,

  /**
   * The status of the searching
   */
  status: _propTypes2.default.oneOf(['fetching', 'fetched', 'failed']),

  /**
   * The type of the search input field
   */
  type: _propTypes2.default.string,

  /**
   * An array of validation messages to display
   */
  validations: _propTypes2.default.array,

  /**
   * The autocomplete value for the field
   */
  autoComplete: _propTypes2.default.string,

  /**
   * The autofocus value for the field
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * The autofocus value for the field
   */
  closeOnClickOutside: _propTypes2.default.bool
};

InputSearch.defaultProps = {
  autoComplete: 'off',
  closeOnClickOutside: true,
  debounce: 500,
  emptyMessage: 'No results found',
  errorMessage: 'There was an unexpected error',
  icon: 'search',
  limit: 5,
  name: 'search',
  results: [],
  status: 'fetched',
  type: 'search',
  valueFormatter: function valueFormatter(value) {
    return value;
  }
};

exports.default = (0, _compose2.default)((0, _withStyles2.default)(_styles2.default), _reactOnclickoutside2.default)(InputSearch);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/input-search/index.js
// module id = 152
// module chunks = 0